export default (theme) => ({
    root: {},
    intro: {
        display: 'flex',
        marginBottom: 16,
    },
    introIcon: {
        flexShrink: 0,
        marginRight: 16,
    },
    groupPhone: {},
    prefix: {
        flexShrink: 0,
        width: 156,
    },
    phone: {},
    cancel: {
        marginRight: 8,
    },
});
